'use client'

import Container from '../../../components/ui/container'
import CMSFormComponent from '../../components/CMSForm'
import { Page, Form as TForm } from '@telesoft/types/payload-types'
import React from 'react'

export type FormBlockProps = Extract<Page['blocks'][0], { blockType: 'form' }>

const FormBlock: React.FC<FormBlockProps> = props => {

  // TODO: decide what to do with container and excerpt
  const { formFields: { container, richText, form } = {} } = props
  if (typeof form === 'string' || form === undefined) return null

  return (
    <Container>
      <CMSFormComponent form={form} />
    </Container>
  )
}

export default FormBlock
